import { motion } from "framer-motion";

// Vague, credible history — industries served, no specific client names.
const INDUSTRIES = [
  "Automotive",
  "Health & Wellness",
  "Real Estate",
  "Music & Media",
  "Hospitality",
  "Fitness",
  "Retail",
  "Professional Services",
];

export const TrustedBy = () => {
  return (
    <section data-testid="trusted-by" className="relative py-12 border-b border-line bg-surface/40">
      <div className="container-x">
        <p className="mono-label text-text-2 text-center mb-8">
          Two decades serving Sacramento businesses · Est. 1998
        </p>
        <div className="flex flex-wrap items-center justify-center gap-3">
          {INDUSTRIES.map((c, i) => (
            <motion.span
              key={c}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.05 }}
              className="font-head font-semibold text-sm sm:text-base text-text-2/70 hover:text-accent transition-colors border border-line px-4 py-2"
            >
              {c}
            </motion.span>
          ))}
        </div>
      </div>
    </section>
  );
};
